import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        list: '=',
        classifiers: '=',
        course: '='
    },
    template: `
        <form ng-submit="vm.applyFilter()">
            <div class="row">
                <label class="label">{{ 'filter.Name' | translate }}</label>
                <div class="items">
                    <input ng-model="vm.filter.name" type="text" class="form-control">
                </div>
            </div>
            <div class="row">
                <label class="label">{{ 'filter.Department' | translate }}</label>
                <div class="items">
                    <select class="form-control" ng-model="vm.filter.departmentId"
                        ng-options="item.id as item.value for item in vm.departments">
                    <option value=""></option>
                    </select>
                </div>
            </div>
            <div class="row">
                <label class="label">{{ 'filter.Role' | translate }}</label>
                <div class="items">
                    <select class="form-control" ng-model="vm.filter.drlRoleId"
                        ng-options="item.id as item.value for item in vm.roles">
                    <option value=""></option>
                </select>
                </div>
            </div>
            <div class="row">
                <label class="label">{{ 'filter.Level' | translate }}</label>
                <div class="items">
                    <select class="form-control" ng-model="vm.filter.levelId"
                        ng-options="item.id as item.value for item in vm.levels">
                    <option value=""></option>
                </select>
                </div>
            </div>
            <div class="row">
                <label class="label">{{ 'filter.Status' | translate }}</label>
                <div class="items">
                    <div
                        ng-dropdown-multiselect=""
                        options="vm.multiFilter.statuses.options"
                        selected-model="vm.multiFilter.statuses.model"
                        extra-settings="vm.multiFilter.statuses.settings"
                        translation-texts="vm.filterTranslations">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="items">
                    <a class="btn main small btn-indented" ng-click="vm.applyFilter()">{{ 'general.Search' | translate }}</a>
                </div>
            </div>
        </form>
    `
})
export default class {
    constructor (lodash, UserService, FilterService, SiteService,
                 CLASSIFIER_ENUM, USER_STATUS_ENUM, ROLE_CODE_ENUM, ROLE_PRIVILEGE_ENUM) {
        this.lodash = lodash;
        this.UserService = UserService;
        this.FilterService = FilterService;
        this.SiteService = SiteService;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
        this.ROLE_CODE_ENUM = ROLE_CODE_ENUM;
        this.ROLE_PRIVILEGE_ENUM = ROLE_PRIVILEGE_ENUM;
    }

    $onInit () {
        this.departments = this.classifiers.filter((clf) => clf.type === this.CLASSIFIER_ENUM.KEYS.DEPARTMENT);
        this.roles = this.classifiers.filter((clf) => clf.type === this.CLASSIFIER_ENUM.KEYS.ROLE);
        this.levels = this.classifiers.filter((clf) => clf.type === this.CLASSIFIER_ENUM.KEYS.LEVEL);

        this.initDefaultFilter();
        this.filter = angular.copy(this.defaultFilter);

        this.filterTranslations = this.FilterService.getTranslations();
        this.initMultiFilter();
        this.applyFilter();
    }

    initDefaultFilter () {
        const siteIds = this.SiteService.getSitesByPrivileges(
            [
                this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_MANAGE,
                this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_ADMINISTRATE,
                this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_VIEW_AND_OCCURRENCE_MANAGE
            ],
            false
        ).map((site) => site.id);

        this.defaultFilter = {
            privilegesCheck: false,
            siteIds: siteIds.length ? siteIds : [-1],
            roleCode: this.ROLE_CODE_ENUM.KEYS.EMPLOYEE,
            statuses: [this.USER_STATUS_ENUM.KEYS.ACTIVE, this.USER_STATUS_ENUM.KEYS.NOT_STARTED]
        };
    }

    initMultiFilter () {
        this.multiFilterOptions = {
            statuses: [
                { value: this.USER_STATUS_ENUM.KEYS.ACTIVE, label: this.USER_STATUS_ENUM.LABELS.ACTIVE },
                { value: this.USER_STATUS_ENUM.KEYS.NOT_STARTED, label: this.USER_STATUS_ENUM.LABELS.NOT_STARTED }
            ]
        };

        this.multiFilterDefaultSettings = {
            checkBoxes: true,
            showCheckAll: false,
            showUncheckAll: false,
            smartButtonMaxItems: 3
        };

        this.multiFilter = {
            statuses: {
                model: [],
                options: this.multiFilterOptions.statuses,
                settings: this.multiFilterDefaultSettings
            }
        };
    }

    applyFilter () {
        this.filter = this.lodash.assign(this.filter, { statuses: this.multiFilter.statuses.model.map(status => status.value) });
        this.list.fetch({ expand: 'drlsWithValue,courseUsers' }, this.filter);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/historicOccurrence/employee/customized/filter/index.js